import Table from '@/common/components/Table';
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

export const TableWrapper = styled.div`
	max-height: calc(100vh - 250px);
	overflow: scroll;
`;

const CallingInformationTable = ({ data }) => {
	const headers = [
		'No.',
		'Type',
		'Phone from',
		'Phone to',
		'Datetime call start',
		'Datetime call end',
		'Talking time (s)',
		'Status',
		'Consultant',
		'Provider',
	];
	const raws = data.map((callingInformation, index) => {
		return (
			<tr key={index}>
				<td>{index + 1}</td>
				<td>{callingInformation.type}</td>
				<td>{callingInformation.from}</td>
				<td>{callingInformation.to}</td>
				<td>
					{moment(
						callingInformation.started_at || callingInformation.created_at,
					).format('YYYY-MM-DD HH:mm:ss')}
				</td>
				<td>
					{callingInformation.ended_at
						? moment(callingInformation.ended_at).format('YYYY-MM-DD HH:mm:ss')
						: ''}
				</td>
				<td>{callingInformation.talking_time}</td>
				<td>{callingInformation.call_history?.status}</td>
				<td>{callingInformation.consultant.username}</td>
				<td>{callingInformation.provider}</td>
			</tr>
		);
	});

	return (
		<TableWrapper>
			<Table
				stickyHeader
				className='styled-table'
				headers={headers}
				raws={raws}
			/>
		</TableWrapper>
	);
};

export default CallingInformationTable;
